(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var headers = document.querySelectorAll("[data-celeste-header]");
    var heroPrimary = document.querySelector(".hero-section--primary");
    var pdpGallery = document.querySelector("[data-product-section] [data-pdp-gallery]");
    var mqlPdpUnderHeader = window.matchMedia("(max-width: 899px)");

    function updateHeaderScrolled() {
      var isProductDesktop =
        document.body.classList.contains("template-product");

      headers.forEach(function (header) {
        if (isProductDesktop) {
          header.classList.add("scrolled");
          return;
        }

        var threshold = 80;
        if (heroPrimary) {
          threshold = heroPrimary.offsetHeight - header.offsetHeight;
          if (threshold < 0) threshold = 0;
        } else if (pdpGallery && mqlPdpUnderHeader.matches) {
          var wrap = pdpGallery.closest(".pdp-gallery-wrap");
          var ref = wrap || pdpGallery;
          threshold = ref.offsetHeight - header.offsetHeight;
          if (threshold < 0) threshold = 0;
        }
        if (window.scrollY > threshold) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
      });
    }

    updateHeaderScrolled();
    window.addEventListener("scroll", updateHeaderScrolled, { passive: true });
    window.addEventListener("resize", updateHeaderScrolled, { passive: true });
    if (typeof mqlPdpUnderHeader.addEventListener === "function") {
      mqlPdpUnderHeader.addEventListener("change", updateHeaderScrolled);
    } else if (typeof mqlPdpUnderHeader.addListener === "function") {
      mqlPdpUnderHeader.addListener(updateHeaderScrolled);
    }

    /* Mobile nav */
    var burgers = document.querySelectorAll("[data-mobile-nav-open]");
    var mobileNavs = document.querySelectorAll("[data-mobile-nav]");
    var navBackdrops = document.querySelectorAll("[data-mobile-nav-backdrop]");

    function closeAllMobileNavs() {
      mobileNavs.forEach(function (nav) {
        nav.classList.remove("is-open");
        nav.setAttribute("aria-hidden", "true");
      });
      navBackdrops.forEach(function (bd) {
        bd.classList.remove("is-open");
        bd.setAttribute("aria-hidden", "true");
      });
      document.body.style.overflow = "";
      burgers.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
      });
    }

    function openMobileNav(nav) {
      if (!nav) return;
      nav.classList.add("is-open");
      nav.setAttribute("aria-hidden", "false");
      var bd = nav.previousElementSibling;
      if (bd && bd.getAttribute("data-mobile-nav-backdrop") !== null) {
        bd.classList.add("is-open");
        bd.setAttribute("aria-hidden", "false");
      }
      document.body.style.overflow = "hidden";
    }

    burgers.forEach(function (burger) {
      burger.addEventListener("click", function () {
        var targetId = burger.getAttribute("aria-controls");
        var nav = targetId ? document.getElementById(targetId) : null;
        if (!nav) return;
        var open = nav.classList.contains("is-open");
        if (open) closeAllMobileNavs();
        else {
          closeAllMobileNavs();
          openMobileNav(nav);
          burger.setAttribute("aria-expanded", "true");
        }
      });
    });

    document.querySelectorAll("[data-mobile-nav-close]").forEach(function (btn) {
      btn.addEventListener("click", closeAllMobileNavs);
    });

    document.querySelectorAll("[data-mobile-nav] a").forEach(function (link) {
      link.addEventListener("click", closeAllMobileNavs);
    });

    navBackdrops.forEach(function (bd) {
      bd.addEventListener("click", closeAllMobileNavs);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAllMobileNavs();
    });

    /* Header predictive search */
    (function initHeaderSearch() {
      var searchRoot = document.querySelector("[data-header-search]");
      if (!searchRoot) return;

      var input = searchRoot.querySelector("[data-header-search-input]");
      var resultsEl = searchRoot.querySelector("[data-header-search-results]");
      var statusEl = searchRoot.querySelector("[data-header-search-status]");
      var viewAll = searchRoot.querySelector("[data-header-search-all]");
      var openBtns = document.querySelectorAll("[data-search-open]");
      var limit = parseInt(searchRoot.getAttribute("data-search-limit"), 10) || 6;
      var i18n = (window.Celeste && Celeste.i18n) || {};
      var hint = i18n.searchHint || "Tapez pour rechercher des produits";
      var loading = i18n.searchLoading || "Recherche en cours…";
      var noResults = i18n.searchNoResults || "Aucun produit trouvé";
      var viewAllLabel = i18n.searchViewAll || "Voir tous les résultats";
      var searchOpen = false;
      var debounceTimer = null;
      var fetchAbort = null;
      var minChars = 2;

      function escapeHtml(str) {
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      function setStatus(text) {
        if (statusEl) statusEl.textContent = text;
      }

      function openSearch() {
        closeAllMobileNavs();
        document.dispatchEvent(new CustomEvent("celeste:close-cart"));
        searchRoot.hidden = false;
        searchRoot.setAttribute("aria-hidden", "false");
        requestAnimationFrame(function () {
          searchRoot.classList.add("is-open");
        });
        searchOpen = true;
        openBtns.forEach(function (btn) {
          btn.setAttribute("aria-expanded", "true");
        });
        document.body.style.overflow = "hidden";
        if (input) {
          window.setTimeout(function () {
            input.focus();
          }, 80);
        }
      }

      function closeSearch() {
        searchRoot.classList.remove("is-open");
        searchOpen = false;
        openBtns.forEach(function (btn) {
          btn.setAttribute("aria-expanded", "false");
        });
        searchRoot.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        window.setTimeout(function () {
          if (!searchOpen) searchRoot.hidden = true;
        }, 280);
        if (fetchAbort) fetchAbort.abort();
      }

      function clearResults() {
        if (resultsEl) resultsEl.innerHTML = "";
        if (viewAll) {
          viewAll.hidden = true;
          viewAll.textContent = viewAllLabel;
        }
      }

      function renderResults(products, query) {
        if (!resultsEl) return;
        clearResults();
        if (!products.length) {
          setStatus(noResults);
          return;
        }
        setStatus("");
        var html = "";
        products.forEach(function (product) {
          var img = product.featured_image && product.featured_image.url ? product.featured_image.url : "";
          var imgTag = img
            ? '<img class="header-search__result-img" src="' +
              escapeHtml(img) +
              '" alt="" width="56" height="56" loading="lazy">'
            : '<span class="header-search__result-img header-search__result-img--empty" aria-hidden="true"></span>';
          html +=
            '<li class="header-search__result-item" role="listitem">' +
            '<a class="header-search__result" href="' +
            escapeHtml(product.url) +
            '">' +
            imgTag +
            '<span class="header-search__result-text">' +
            '<span class="header-search__result-title">' +
            escapeHtml(product.title) +
            "</span>" +
            (product.price
              ? '<span class="header-search__result-price">' + escapeHtml(product.price) + "</span>"
              : "") +
            "</span></a></li>";
        });
        resultsEl.innerHTML = html;
        if (viewAll && query) {
          viewAll.href = "/search?q=" + encodeURIComponent(query) + "&type=product";
          viewAll.hidden = false;
          viewAll.textContent = viewAllLabel + ' "' + query + '"';
        }
      }

      function fetchSuggestions(query) {
        if (fetchAbort) fetchAbort.abort();
        fetchAbort = new AbortController();
        var url =
          "/search/suggest.json?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product&resources[limit]=" +
          limit +
          "&resources[options][unavailable_products]=last";

        setStatus(loading);
        clearResults();

        fetch(url, {
          headers: { Accept: "application/json" },
          signal: fetchAbort.signal,
        })
          .then(function (res) {
            if (!res.ok) throw new Error("search failed");
            return res.json();
          })
          .then(function (data) {
            var products =
              data.resources && data.resources.results && data.resources.results.products
                ? data.resources.results.products
                : [];
            renderResults(products, query);
          })
          .catch(function (err) {
            if (err.name === "AbortError") return;
            setStatus(noResults);
            clearResults();
          });
      }

      function onInputChange() {
        var query = input ? input.value.trim() : "";
        if (query.length < minChars) {
          if (fetchAbort) fetchAbort.abort();
          clearResults();
          setStatus(hint);
          if (viewAll) viewAll.hidden = true;
          return;
        }
        if (debounceTimer) window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          fetchSuggestions(query);
        }, 280);
      }

      openBtns.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          if (searchOpen) closeSearch();
          else openSearch();
        });
      });

      searchRoot.querySelectorAll("[data-search-close]").forEach(function (btn) {
        btn.addEventListener("click", closeSearch);
      });

      if (input) {
        input.addEventListener("input", onInputChange);
        input.addEventListener("keydown", function (e) {
          if (e.key === "Escape") {
            e.preventDefault();
            closeSearch();
          }
        });
      }

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && searchOpen) closeSearch();
      });

      document.addEventListener("celeste:close-search", closeSearch);
    })();

    /* Reveal on scroll */
    var revealEls = document.querySelectorAll(".reveal");
    if ("IntersectionObserver" in window && revealEls.length) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add("visible");
          });
        },
        { threshold: 0.12 }
      );
      revealEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add("visible");
      });
    }

    /* Second hero — entrance on scroll */
    var secondHero = document.querySelector("[data-second-hero]");
    if (secondHero && "IntersectionObserver" in window) {
      var heroAnimObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-inview");
              heroAnimObs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      heroAnimObs.observe(secondHero);
    } else if (secondHero) {
      secondHero.classList.add("is-inview");
    }

    /* Recently viewed products (PDP) */
    (function initRecentlyViewed() {
      var STORAGE_KEY = "celeste_recent_products";
      var MAX_RECENT = 4;

      function getRecentHandles() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          return raw ? JSON.parse(raw) : [];
        } catch (err) {
          return [];
        }
      }

      function saveRecentProduct(handle) {
        if (!handle) return;
        var list = getRecentHandles().filter(function (h) {
          return h !== handle;
        });
        list.unshift(handle);
        if (list.length > MAX_RECENT + 1) list = list.slice(0, MAX_RECENT + 1);
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (err) {
          /* storage full or disabled */
        }
      }

      function formatMoney(cents) {
        var cfg = window.Celeste || {};
        var amount = (cents / 100).toFixed(2);
        var format = cfg.moneyFormat || "{{amount}}";
        if (format.indexOf("{{") === -1) return amount;
        return format
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      function escapeHtml(str) {
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      function getSizeOption(product) {
        if (!product.options || !product.options.length) return null;
        for (var i = 0; i < product.options.length; i++) {
          var name = String(product.options[i]).trim().toLowerCase();
          if (name === "taille" || name === "size") {
            return { position: i + 1, name: product.options[i] };
          }
        }
        return null;
      }

      function getSizeValues(variants, position) {
        var key = "option" + position;
        var seen = {};
        var values = [];
        variants.forEach(function (variant) {
          var val = variant[key];
          if (val && !seen[val]) {
            seen[val] = true;
            values.push(val);
          }
        });
        return values;
      }

      function initRecentPcardSizes(container) {
        container.querySelectorAll("[data-pcard]").forEach(function (card) {
          if (card.getAttribute("data-pcard-has-size") !== "true") return;
          var optionPos = card.getAttribute("data-pcard-size-option");
          var script = card.querySelector("[data-pcard-variants]");
          if (!script) return;
          var variants;
          try {
            variants = JSON.parse(script.textContent);
          } catch (err) {
            return;
          }
          card.querySelectorAll("[data-pcard-size]").forEach(function (pill) {
            var val = pill.getAttribute("data-size-value");
            var key = "option" + optionPos;
            var match = null;
            for (var i = 0; i < variants.length; i++) {
              if (variants[i][key] === val) {
                match = variants[i];
                break;
              }
            }
            if (!match || !match.available) pill.disabled = true;
          });
        });
      }

      function renderProductCard(product) {
        var i18n = (window.Celeste && Celeste.i18n) || {};
        var atcLabel = i18n.addToCart || "Ajouter au panier";
        var soldOutLabel = i18n.soldOut || "Épuisé";

        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) {
            variant = product.variants[i];
            break;
          }
        }
        if (!variant) variant = product.variants[0];
        if (!variant) return "";

        var sizeOpt = getSizeOption(product);
        var onSale =
          variant.compare_at_price != null && variant.compare_at_price > variant.price;
        var img =
          product.featured_image ||
          (product.images && product.images.length ? product.images[0] : "");
        var imgTag = img
          ? '<img class="pcard__img" src="' +
            escapeHtml(img) +
            '" alt="' +
            escapeHtml(product.title) +
            '" loading="lazy" width="900" height="1200">'
          : '<div class="pcard__img-empty" aria-hidden="true"></div>';

        var prices = onSale
          ? '<span class="pcard__price pcard__price--sale">' +
            formatMoney(variant.price) +
            '</span><span class="pcard__price pcard__price--compare">' +
            formatMoney(variant.compare_at_price) +
            "</span>"
          : '<span class="pcard__price">' + formatMoney(variant.price) + "</span>";

        var sizesHtml = "";
        if (sizeOpt) {
          var sizeValues = getSizeValues(product.variants, sizeOpt.position);
          var pills = sizeValues
            .map(function (value) {
              return (
                '<button type="button" class="pcard__size-pill" role="option" data-pcard-size data-size-value="' +
                escapeHtml(value) +
                '" aria-selected="false">' +
                escapeHtml(value) +
                "</button>"
              );
            })
            .join("");
          sizesHtml =
            '<div class="pcard__sizes" data-pcard-sizes hidden>' +
            '<span class="pcard__sizes-label">' +
            escapeHtml(sizeOpt.name) +
            '</span><div class="pcard__sizes-list" role="listbox" aria-label="' +
            escapeHtml(sizeOpt.name) +
            '">' +
            pills +
            "</div></div>";
        }

        var atcText = variant.available ? atcLabel : soldOutLabel;
        var atcDisabled = variant.available ? "" : ' disabled aria-disabled="true"';
        var sizeAttrs = sizeOpt
          ? ' data-pcard-has-size="true" data-pcard-size-option="' + sizeOpt.position + '"'
          : "";

        return (
          '<article class="pcard reveal visible" data-pcard data-product-handle="' +
          escapeHtml(product.handle) +
          '"' +
          sizeAttrs +
          ">" +
          '<div class="pcard__frame">' +
          '<a class="pcard__media-link" href="' +
          escapeHtml(product.url) +
          '" tabindex="-1" aria-hidden="true">' +
          imgTag +
          "</a>" +
          '<div class="pcard__badges">' +
          (onSale ? '<span class="pcard__badge pcard__badge--sale">Promo</span>' : "") +
          "</div>" +
          '<div class="pcard__overlay">' +
          sizesHtml +
          '<button type="button" class="pcard__atc-btn btn btn--cart" data-pcard-atc data-variant-id="' +
          variant.id +
          '"' +
          atcDisabled +
          ">" +
          '<span data-pcard-atc-label>' +
          escapeHtml(atcText) +
          "</span></button></div></div>" +
          '<div class="pcard__body">' +
          '<a class="pcard__title-link" href="' +
          escapeHtml(product.url) +
          '">' +
          escapeHtml(product.title) +
          "</a>" +
          '<div class="pcard__prices">' +
          prices +
          "</div></div>" +
          '<script type="application/json" data-pcard-variants>' +
          JSON.stringify(product.variants) +
          "</script></article>"
        );
      }

      function fetchProduct(handle) {
        return fetch("/products/" + encodeURIComponent(handle) + ".js", {
          headers: { Accept: "application/json" },
        }).then(function (res) {
          if (!res.ok) throw new Error("product not found");
          return res.json();
        });
      }

      function renderRecentPanel(grid, emptyEl, currentHandle) {
        var handles = getRecentHandles().filter(function (h) {
          return h && h !== currentHandle;
        });
        handles = handles.slice(0, MAX_RECENT);

        if (!handles.length) {
          grid.innerHTML = "";
          grid.hidden = true;
          if (emptyEl) emptyEl.hidden = false;
          return;
        }

        Promise.all(
          handles.map(function (handle) {
            return fetchProduct(handle).catch(function () {
              return null;
            });
          })
        ).then(function (products) {
          var valid = products.filter(Boolean);
          if (!valid.length) {
            grid.innerHTML = "";
            grid.hidden = true;
            if (emptyEl) emptyEl.hidden = false;
            return;
          }

          grid.innerHTML = valid.map(renderProductCard).join("");
          initRecentPcardSizes(grid);
          grid.hidden = false;
          if (emptyEl) emptyEl.hidden = true;
        });
      }

      var productSection = document.querySelector("[data-product-section][data-product-handle]");
      if (productSection) {
        saveRecentProduct(productSection.getAttribute("data-product-handle"));
      }

      document.querySelectorAll("[data-recent-grid]").forEach(function (grid) {
        var root = grid.closest("[data-tabbed-products]");
        if (!root) return;

        var emptyEl = root.querySelector("[data-recent-empty]");
        var currentHandle = root.getAttribute("data-current-handle") || "";
        var recentTab = root.querySelector('[data-tab="recent"]');
        var loaded = false;

        function loadRecent() {
          if (loaded) return;
          loaded = true;
          renderRecentPanel(grid, emptyEl, currentHandle);
        }

        if (recentTab) {
          recentTab.addEventListener("click", loadRecent);
        }

        if (recentTab && recentTab.classList.contains("is-active")) {
          loadRecent();
        }
      });
    })();

    /* Tabbed product grid */
    document.querySelectorAll("[data-tabbed-products]").forEach(function (root) {
      var tabs = root.querySelectorAll(".tabbed-products__tab");
      var panels = root.querySelectorAll("[data-tab-panel]");
      var indicator = root.querySelector("[data-tab-indicator]");
      var tabStrip = root.querySelector(".tabbed-products__tabs");

      function moveIndicator(activeTab) {
        if (!indicator || !tabStrip || !activeTab) return;
        var stripRect = tabStrip.getBoundingClientRect();
        var tabRect = activeTab.getBoundingClientRect();
        var left = tabRect.left - stripRect.left + tabStrip.scrollLeft;
        indicator.style.width = tabRect.width + "px";
        indicator.style.left = left + "px";
      }

      function scrollActiveTabIntoView(activeTab) {
        if (!tabStrip || !activeTab) return;
        if (!window.matchMedia("(max-width: 1024px)").matches) return;
        var stripRect = tabStrip.getBoundingClientRect();
        var tabRect = activeTab.getBoundingClientRect();
        var offset = tabRect.left - stripRect.left - (stripRect.width - tabRect.width) / 2;
        tabStrip.scrollTo({ left: tabStrip.scrollLeft + offset, behavior: "smooth" });
      }

      function activateTab(name) {
        var activeBtn = null;
        tabs.forEach(function (btn) {
          var on = btn.getAttribute("data-tab") === name;
          btn.classList.toggle("is-active", on);
          btn.setAttribute("aria-selected", on ? "true" : "false");
          if (on) activeBtn = btn;
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute("data-tab-panel") === name;
          panel.classList.toggle("is-active", on);
          if (on) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "hidden");
          }
        });
        moveIndicator(activeBtn);
        scrollActiveTabIntoView(activeBtn);
      }

      tabs.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var name = btn.getAttribute("data-tab");
          if (name) activateTab(name);
        });
      });

      window.addEventListener(
        "resize",
        function () {
          var cur = root.querySelector(".tabbed-products__tab.is-active");
          moveIndicator(cur);
        },
        { passive: true }
      );

      var initial = root.querySelector(".tabbed-products__tab.is-active");
      if (initial) {
        activateTab(initial.getAttribute("data-tab"));
      } else if (tabs.length) {
        activateTab(tabs[0].getAttribute("data-tab"));
      }
    });

    /* SEO read more */
    document.querySelectorAll("[data-seo-section]").forEach(function (section) {
      var btn = section.querySelector("[data-read-more]");
      var expanded = section.querySelector("[data-seo-expanded]");
      var labelEl = section.querySelector("[data-read-more-label]");
      if (!btn || !expanded || !labelEl) return;
      var more = section.getAttribute("data-read-more-label") || "Read More";
      var less = section.getAttribute("data-read-less-label") || "Read Less";
      btn.addEventListener("click", function () {
        var open = expanded.classList.toggle("visible");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        labelEl.textContent = open ? less : more;
      });
    });

    /* Sets & Parures — combo modals */
    document.querySelectorAll("[data-combo-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var dialogId = trigger.getAttribute("data-combo-dialog");
        var dialog = dialogId ? document.getElementById(dialogId) : null;
        if (dialog && typeof dialog.showModal === "function") {
          dialog.showModal();
          document.body.style.overflow = "hidden";
        }
      });
    });

    function closeComboModal(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === "function") dialog.close();
      document.body.style.overflow = "";
    }

    document.querySelectorAll("[data-combo-modal]").forEach(function (dialog) {
      dialog.addEventListener("click", function (e) {
        if (e.target === dialog) closeComboModal(dialog);
      });

      dialog.querySelectorAll("[data-combo-close]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          closeComboModal(dialog);
        });
      });

      dialog.addEventListener("close", function () {
        document.body.style.overflow = "";
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      document.querySelectorAll("[data-combo-modal][open]").forEach(function (dialog) {
        closeComboModal(dialog);
      });
    });

    document.querySelectorAll("[data-combo-atc]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled || btn.classList.contains("is-added")) return;
        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;

        var labelEl = btn.querySelector("[data-combo-atc-label]");
        var defaultLabel = labelEl ? labelEl.textContent : "";
        btn.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("add failed");
            return res.json();
          })
          .then(function (data) {
            btn.classList.add("is-added");
            if (labelEl) labelEl.textContent = "Ajouté au panier ✓";
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent("cart:updated"));
          })
          .catch(function () {
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defaultLabel;
          });
      });
    });

    /* Scroll to top */
    var scrollBtn = document.querySelector(".scroll-top");
    if (scrollBtn) {
      function updateScrollBtn() {
        var show = window.scrollY > 400;
        scrollBtn.style.opacity = show ? "1" : "0";
        scrollBtn.style.pointerEvents = show ? "auto" : "none";
      }
      updateScrollBtn();
      window.addEventListener("scroll", updateScrollBtn, { passive: true });
      scrollBtn.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    /* Cart drawer, AJAX add-to-cart, toast */
    (function initCartDrawer() {
      var cfg = window.Celeste || {};
      var i18n = cfg.i18n || {};
      var drawer = document.getElementById("CartDrawer");
      var drawerBody = document.getElementById("CartDrawerBody");
      var drawerFoot = document.getElementById("CartDrawerFoot");
      var drawerSubtotal = document.getElementById("CartDrawerSubtotal");
      var toast = document.getElementById("CartToast");
      var toastTimer = null;
      var drawerOpen = false;
      var skipToastOnce = false;

      if (!drawer || !drawerBody) return;

      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        var format = cfg.moneyFormat || "{{amount}}";
        if (format.indexOf("{{") === -1) return amount;
        return format
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      function escapeHtml(str) {
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      function updateBadge(count) {
        var cartLink = document.querySelector("[data-cart-open]");
        if (!cartLink) return;
        var badge = cartLink.querySelector("[data-cart-badge]");
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "celeste-header__cart-badge";
          badge.setAttribute("data-cart-badge", "");
          cartLink.appendChild(badge);
        }
        if (count > 0) {
          badge.textContent = String(count);
          badge.hidden = false;
          badge.classList.remove("celeste-header__cart-badge--empty");
          badge.classList.remove("is-bump");
          void badge.offsetWidth;
          badge.classList.add("is-bump");
        } else {
          badge.textContent = "0";
          badge.hidden = true;
          badge.classList.add("celeste-header__cart-badge--empty");
        }
      }

      function renderCart(cart) {
        if (!cart || !cart.items) return;

        updateBadge(cart.item_count);

        if (cart.item_count === 0) {
          if (drawerFoot) drawerFoot.hidden = true;
          drawerBody.innerHTML =
            '<div class="cart-drawer__empty">' +
            "<p>" +
            escapeHtml(i18n.drawerEmpty || "Votre panier est vide.") +
            "</p>" +
            '<a class="btn cart-drawer__continue" href="' +
            escapeHtml(cfg.routes && cfg.routes.collections ? cfg.routes.collections : "/collections/all") +
            '">' +
            escapeHtml(i18n.drawerContinue || "Continuer les achats") +
            "</a></div>";
          return;
        }

        if (drawerFoot) drawerFoot.hidden = false;
        if (drawerSubtotal) {
          drawerSubtotal.innerHTML =
            "<span>" +
            escapeHtml(i18n.drawerSubtotal || "Sous-total") +
            "</span><strong>" +
            formatMoney(cart.items_subtotal_price) +
            "</strong>";
        }

        var html = '<ul class="cart-drawer__list" role="list">';
        cart.items.forEach(function (item) {
          var img = item.image
            ? '<img class="cart-drawer__item-img" src="' +
              escapeHtml(item.image) +
              '" alt="" width="72" height="72" loading="lazy">'
            : '<span class="cart-drawer__item-img cart-drawer__item-img--placeholder" aria-hidden="true"></span>';
          var variant =
            item.variant_title && item.variant_title !== "Default Title"
              ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + "</p>"
              : "";
          html +=
            '<li class="cart-drawer__item" role="listitem">' +
            '<a class="cart-drawer__item-media" href="' +
            escapeHtml(item.url) +
            '" tabindex="-1" aria-hidden="true">' +
            img +
            "</a>" +
            '<div class="cart-drawer__item-info">' +
            '<a class="cart-drawer__item-title" href="' +
            escapeHtml(item.url) +
            '">' +
            escapeHtml(item.product_title) +
            "</a>" +
            variant +
            '<p class="cart-drawer__item-meta">' +
            escapeHtml(String(item.quantity)) +
            " × " +
            formatMoney(item.final_price) +
            "</p>" +
            "</div>" +
            '<p class="cart-drawer__item-line">' +
            formatMoney(item.final_line_price) +
            "</p></li>";
        });
        html += "</ul>";
        drawerBody.innerHTML = html;
      }

      function refreshCart() {
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (res) {
            if (!res.ok) throw new Error("cart fetch failed");
            return res.json();
          })
          .then(function (cart) {
            renderCart(cart);
            return cart;
          });
      }

      function openDrawer() {
        document.dispatchEvent(new CustomEvent("celeste:close-search"));
        drawer.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add("is-open");
        });
        document.body.style.overflow = "hidden";
        drawerOpen = true;
        drawer.setAttribute("aria-hidden", "false");
      }

      function closeDrawer() {
        drawer.classList.remove("is-open");
        document.body.style.overflow = "";
        drawerOpen = false;
        drawer.setAttribute("aria-hidden", "true");
        window.setTimeout(function () {
          if (!drawerOpen) drawer.hidden = true;
        }, 320);
      }

      function showToast() {
        if (!toast) return;
        toast.hidden = false;
        requestAnimationFrame(function () {
          toast.classList.add("is-visible");
        });
        if (toastTimer) window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(hideToast, 3800);
      }

      function hideToast() {
        if (!toast) return;
        toast.classList.remove("is-visible");
        window.setTimeout(function () {
          if (!toast.classList.contains("is-visible")) toast.hidden = true;
        }, 320);
      }

      function onCartUpdated(options) {
        var opts = options || {};
        refreshCart();
        if (!opts.silent && !skipToastOnce) showToast();
        skipToastOnce = false;
      }

      document.addEventListener("cart:updated", function (e) {
        onCartUpdated(e.detail || {});
      });

      document.addEventListener("celeste:close-cart", closeDrawer);

      document.querySelectorAll("[data-cart-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          openDrawer();
          refreshCart();
        });
      });

      document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
        btn.addEventListener("click", closeDrawer);
      });

      if (toast) {
        toast.addEventListener("click", function () {
          hideToast();
          openDrawer();
          refreshCart();
        });
      }

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && drawerOpen) closeDrawer();
      });

      document.querySelectorAll("form.pdp-form, form.featured-product__form").forEach(function (form) {
        form.addEventListener("submit", function (e) {
          if (form.hasAttribute("data-ajax-cart-disabled")) return;
          e.preventDefault();

          var addBtn = form.querySelector("[data-add-to-cart], [type='submit'][name='add']");
          var defaultLabel = addBtn ? addBtn.textContent : "";
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.classList.add("is-adding");
          }

          fetch("/cart/add.js", {
            method: "POST",
            body: new FormData(form),
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          })
            .then(function (res) {
              if (!res.ok) throw new Error("add failed");
              return res.json();
            })
            .then(function (data) {
              if (addBtn) {
                addBtn.disabled = false;
                addBtn.classList.remove("is-adding");
              }
              var drawerEl = form.querySelector("[data-options-drawer]");
              var overlay = form.querySelector("[data-drawer-overlay]");
              if (drawerEl) drawerEl.classList.remove("is-open");
              if (overlay) overlay.classList.remove("is-open");
              document.dispatchEvent(new CustomEvent("cart:updated"));
            })
            .catch(function () {
              if (addBtn) {
                addBtn.disabled = false;
                addBtn.classList.remove("is-adding");
              }
              form.setAttribute("data-ajax-cart-disabled", "");
              form.submit();
            });
        });
      });

      if (document.querySelector("[data-cart-section]")) {
        skipToastOnce = true;
        refreshCart();
      }
    })();

    /* Product card quick-add */
    (function initPcardQuickAdd() {
      function parseVariants(card) {
        var script = card.querySelector("[data-pcard-variants]");
        if (!script) return [];
        try {
          return JSON.parse(script.textContent);
        } catch (err) {
          return [];
        }
      }

      function findAvailableVariant(variants, optionPosition, value) {
        var key = "option" + optionPosition;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v[key] === value && v.available) return v;
        }
        return null;
      }

      function variantExistsForSize(variants, optionPosition, value) {
        var key = "option" + optionPosition;
        for (var j = 0; j < variants.length; j++) {
          if (variants[j][key] === value) return variants[j];
        }
        return null;
      }

      function addToCart(variantId, btn, card, labelEl, defaultLabel) {
        if (!variantId || !btn || btn.classList.contains("is-adding")) return;
        btn.classList.add("is-adding");
        btn.disabled = true;

        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("add failed");
            return res.json();
          })
          .then(function (data) {
            btn.classList.remove("is-adding");
            btn.classList.add("is-added");
            if (labelEl) labelEl.textContent = "Ajouté ✓";
            btn.disabled = false;
            if (card) {
              card.classList.remove("is-sizes-open");
              var sizes = card.querySelector("[data-pcard-sizes]");
              if (sizes) sizes.hidden = true;
            }
            document.dispatchEvent(new CustomEvent("cart:updated"));
            window.setTimeout(function () {
              btn.classList.remove("is-added");
              if (labelEl) labelEl.textContent = defaultLabel;
            }, 2200);
          })
          .catch(function () {
            btn.classList.remove("is-adding");
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defaultLabel;
          });
      }

      document.addEventListener("click", function (e) {
        var sizeBtn = e.target.closest("[data-pcard-size]");
        if (sizeBtn) {
          e.preventDefault();
          e.stopPropagation();
          var sizeCard = sizeBtn.closest("[data-pcard]");
          if (!sizeCard || sizeBtn.disabled) return;

          var optionPos = sizeCard.getAttribute("data-pcard-size-option");
          var sizeValue = sizeBtn.getAttribute("data-size-value");
          var sizeVariants = parseVariants(sizeCard);
          var sizeVariant = findAvailableVariant(sizeVariants, optionPos, sizeValue);
          if (!sizeVariant) return;

          sizeCard.querySelectorAll("[data-pcard-size]").forEach(function (pill) {
            pill.setAttribute("aria-selected", pill === sizeBtn ? "true" : "false");
          });

          var sizeAtc = sizeCard.querySelector("[data-pcard-atc]");
          if (sizeAtc) sizeAtc.setAttribute("data-variant-id", sizeVariant.id);

          var sizeLabel = sizeAtc && sizeAtc.querySelector("[data-pcard-atc-label]");
          var sizeDefault = sizeLabel ? sizeLabel.textContent : "";
          addToCart(String(sizeVariant.id), sizeAtc, sizeCard, sizeLabel, sizeDefault);
          return;
        }

        var atcBtn = e.target.closest("[data-pcard-atc]");
        if (!atcBtn) return;
        e.preventDefault();
        e.stopPropagation();

        var card = atcBtn.closest("[data-pcard]");
        if (!card || atcBtn.disabled) return;

        var labelEl = atcBtn.querySelector("[data-pcard-atc-label]");
        var defaultLabel = labelEl ? labelEl.textContent : "";

        if (card.getAttribute("data-pcard-has-size") === "true") {
          var sizesPanel = card.querySelector("[data-pcard-sizes]");
          if (sizesPanel && sizesPanel.hidden) {
            card.classList.add("is-sizes-open");
            sizesPanel.hidden = false;
            return;
          }
        }

        addToCart(atcBtn.getAttribute("data-variant-id"), atcBtn, card, labelEl, defaultLabel);
      });

      document.querySelectorAll("[data-pcard]").forEach(function (card) {
        if (card.getAttribute("data-pcard-has-size") !== "true") return;
        var optionPos = card.getAttribute("data-pcard-size-option");
        var variants = parseVariants(card);
        card.querySelectorAll("[data-pcard-size]").forEach(function (pill) {
          var val = pill.getAttribute("data-size-value");
          var match = variantExistsForSize(variants, optionPos, val);
          if (!match || !match.available) pill.disabled = true;
        });
      });
    })();
  });
})();
